export default __webpack_public_path__ + "static/media/consumer_badge.42bba9b5.png";